<template>
    <transition name="call-modal-fade" tag="div">
        <div 
            ref="call-modal" 
            class="call-modal" 
            :class="classes" 
            v-if="showModal"
            :style="modalStyle"
            @mousedown="startDrag">
            <div class="call-status drag-handle">
                <div class="call-status-header">
                    <span class="icon-with-badge">
                        <fluent-icon class="inbox-icon" icon="brand-whatsapp" size="12" />
                    </span>
                    Ligação do WhatsApp
                </div>
                <span class="beta-label">BETA</span>
            </div>
            <div class="call-participant-name" v-if="displayName">
                <strong>{{ displayName }}</strong>
            </div>
            <audio ref="roomaudio" id="roomaudio" controls autoplay v-show="joined"></audio>
            <div class="call-button-container" v-if="!joined && !joining">
                <woot-button
                    v-tooltip="$t('CONVERSATION.CALL_REJECT')"
                    color-scheme="alert"
                    icon="call"
                    classNames="reject-button"
                    @click="onRejectAction">
                    {{$t('CONVERSATION.CALL_REJECT')}}
                </woot-button>
                <woot-button
                    v-tooltip="$t('CONVERSATION.CALL_ACCEPT')"
                    color-scheme="success"
                    icon="call"
                    classNames="accept-button"
                    @click="onAcceptAction">
                    {{$t('CONVERSATION.CALL_ACCEPT')}}
                </woot-button>
            </div>
            <div v-else-if="joined" class="call-button-container">
                <woot-button
                    v-tooltip="$t('CONVERSATION.CALL_END')"
                    color-scheme="alert"
                    icon="call"
                    classNames="reject-button"
                    @click="onHangup">
                    {{$t('CONVERSATION.CALL_END')}}
                </woot-button>
                <woot-button
                    color-scheme="primary"
                    :icon="muted ? 'microphone' : 'microphone-off'"
                    @click="toogleAudioMute">
                    <span>{{ parsedLabelMute }}</span>
                </woot-button>
            </div>
            <div v-else-if="joining" class="call-button-container">
                <p>Conectando...</p>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import janusMixin from '../mixins/janusMixin.js';
import CallLogAPI from 'dashboard/api/calllog';

export default {
    name: 'CallAttendanceModal',
    mixins: [janusMixin],
    data() {
        return {
            showModal: false,
            participantId: null,
            participants: [],
            conversation: null,
            classes: [],
            // Drag and drop
            isDragging: false,
            dragStartX: 0,
            dragStartY: 0,
            modalX: null,
            modalY: null,
            initialX: null,
            initialY: null,
            cbOnHangup: () => {},
        };
    },
    computed: {
        ...mapGetters({
            chatList: 'getAllConversations',
            getCurrentAccountId: 'getCurrentAccountId'
        }),
        sender() {
            return this.conversation?.meta?.sender || {};
        },
        roomId() {
            return Number(this.sender?.phone_number.replace(/\D/g, ''));
        },
        displayName() {
            return this.sender?.name;
        },
        conversationFilters() {
            return {
                inboxId: undefined,
                assigneeType: 'all',
                status: 'open',
                page: 1,
                labels: undefined,
                teamId: undefined,
                conversationType: undefined,
                folders: undefined,
            };
        },
        parsedLabelMute() {
            return this.muted ? this.$t('CONVERSATION.UNMUTE') : this.$t('CONVERSATION.MUTE');
        },
        modalStyle() {
            if (this.modalX !== null && this.modalY !== null) {
                return {
                    left: `${this.modalX}px`,
                    top: `${this.modalY}px`,
                    right: 'auto',
                };
            }
            return {};
        },
    },
    mounted() {
        this.stopCallAudio('MOUNTED');
        this.initEvents();
        this.$nextTick(() => {            
            if (this.chatList.length === 0 && this.getCurrentAccountId) {
                this.$store.dispatch('fetchAllConversations', this.conversationFilters);
            }
        });
    },
    beforeDestroy() {
        this.stopCallAudio('BEFORE_DESTROY');
        this.removeDragListeners();
    },
    methods: {
        initEvents() {
            window.bus.$on('open-call-modal', ({ conversationId, origin, element, cbOnHangup = () => {} }) => {
              const [chat] = this.chatList.filter(c => c.id == conversationId);
              this.conversation = chat;
              this.showModal = true;
                            this.joining = false;
                            this.joined = false;
              if (origin === 'list') {
                  this.classes = ['call-modal-from-list'];
              } else if (origin === 'incoming_auto') {
                  this.classes = ['call-modal-bottom-right'];
              } else {
                  this.classes = [];
              }
              this.cbOnHangup = cbOnHangup;
              this.stopCallAudio('INIT_EVENTS');
              this.startCallAudio();
              // Reset position when opening
              this.$nextTick(() => {
                  this.resetPosition();
              });
            });
            window.bus.$on('open-call-outgoing-modal', ({ conversationId, element, cbOnHangup = () => {} }) => {
              const [chat] = this.chatList.filter(c => c.id == conversationId);
              this.conversation = chat;
              this.showModal = true;
              this.joining = true;
              this.joined = false;
              this.classes = [];
              this.cbOnHangup = cbOnHangup;
              this.stopCallAudio('INIT_EVENTS:ON:open-call-outgoing-modal');
              this.callOutgoing();
              // Reset position when opening
              this.$nextTick(() => {
                  this.resetPosition();
              });
            });
            window.bus.$on('calllog_updated', (data) => {
                console.log('calllog_status:', data.calllog.status);
                if (
                    this.conversation && 
                    data.calllog.conversation_id === this.conversation.primary_key && 
                    ['call_completed', 'call_failed'].includes(data.calllog.status)
                ) {
                    this.onHangup();
                }
            });
        },
        async onAcceptAction() {
            this.stopCallAudio('ACCEPT_ACTION');
            await this.initializePeerConnection();
            await this.joinRoom();
        },
        async callOutgoing() {
            await this.initializePeerConnection();
            this.stopCallAudio('CALL_OUTGOING');
            await this.joinRoomOutgoing();
        },
        onHangup() {
            this.stopCallAudio('ON:HANGUP');
            this.hangup();
            this.cbOnHangup();
            this.showModal = false;
        },
        onRejectAction() {
            this.stopCallAudio('REJECT_ACTION');
            this.rejectCall();
            this.showModal = false;
        },
        onCloseModalClickOutside() {
            this.stopCallAudio('CLOSE_MODAL_CLICK_OUTSIDE');
            this.showModal = false;
        },
        // Drag and drop methods
        startDrag(e) {
            // Only start drag if clicking on the header area
            if (!e.target.closest('.drag-handle')) return;
            
            this.isDragging = true;
            const modal = this.$refs['call-modal'];
            
            // Get current position or calculate initial position
            if (this.modalX === null || this.modalY === null) {
                const rect = modal.getBoundingClientRect();
                this.modalX = rect.left;
                this.modalY = rect.top;
            }
            
            this.dragStartX = e.clientX - this.modalX;
            this.dragStartY = e.clientY - this.modalY;
            
            document.addEventListener('mousemove', this.onDrag);
            document.addEventListener('mouseup', this.stopDrag);
            
            // Add dragging class for cursor change
            modal.classList.add('dragging');
        },
        onDrag(e) {
            if (!this.isDragging) return;
            
            e.preventDefault();
            
            let newX = e.clientX - this.dragStartX;
            let newY = e.clientY - this.dragStartY;
            
            // Constrain to viewport
            const modal = this.$refs['call-modal'];
            const modalWidth = modal.offsetWidth;
            const modalHeight = modal.offsetHeight;
            const maxX = window.innerWidth - modalWidth;
            const maxY = window.innerHeight - modalHeight;
            
            newX = Math.max(0, Math.min(newX, maxX));
            newY = Math.max(0, Math.min(newY, maxY));
            
            this.modalX = newX;
            this.modalY = newY;
        },
        stopDrag() {
            this.isDragging = false;
            const modal = this.$refs['call-modal'];
            if (modal) {
                modal.classList.remove('dragging');
            }
            this.removeDragListeners();
        },
        removeDragListeners() {
            document.removeEventListener('mousemove', this.onDrag);
            document.removeEventListener('mouseup', this.stopDrag);
        },
        resetPosition() {
            // Reset to default CSS positioning
            this.modalX = null;
            this.modalY = null;
        },
        stopCallAudio(reason) {
            console.log(`Parando o toque... (${reason})`);
            if (window.stopLoopingCallAudioAlert) {
                console.log("Toque parado");
                window.stopLoopingCallAudioAlert();
            }
        },
        startCallAudio() {
            if (window.startLoopingCallAudioAlert) {
                window.startLoopingCallAudioAlert();
            }
        },
    }
};
</script>

<style scoped lang="scss">
.call-modal {
    position: fixed;
    width: 370px;
    margin: auto;
    z-index: 9999;
    top: 130px;
    right: 25px;
    background: #fff;
    padding: 16px 8px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s ease;
    
    &.dragging {
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.35);
        cursor: move;
    }
    
    &.call-modal-from-list {
        right: auto !important;
        left: calc(50% - (370px / 2)) !important;
        top: calc(50% - 100px) !important;
    }

    &.call-modal-bottom-right {
        top: auto !important;
        bottom: 25px !important;
        right: 25px !important;
        left: auto !important;
    }
}

.call-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    
    &.drag-handle {
        cursor: move;
        user-select: none;
        padding: 4px 0;
    }
    
    .call-status-header {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        .icon-with-badge {
            background: #23853B;
            color: #fff;
            padding: 3px 7px;
            border-radius: 50%;
            margin-right: 12px;
        }
    }
    .beta-label {
        background: #E8EEFF;
        border-radius: 5px;
        padding: 2px 6px;
        font-size: 10px;
        font-weight: 600;
        color: #6095D9;
    }
}

.call-participant-name {
    text-align: center;
    margin-bottom: 8px;
    font-size: 16px;
}

.call-button-container {
    display: flex;
    justify-content: space-around;
    margin-top: 12px;
    .reject-button {
        border-color: #FF4C4C;
        color: #FF4C4C;
        background-color: #FFF;
        box-shadow: 0px 4px 4px 0px #FFF;
        flex: 1;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        &:hover {
            background-color: #FF4C4C;
            color: #FFF;
        }
    }
    .accept-button {
        background-color: #4CAF50;
        color: #FFF;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        flex: 1;
        margin-left: 10px;
        display: flex;
        justify-content: center;
    }
}
</style>